import client from '@util/api'
import { SYSADMIN } from '../../../route.const'
import { INotification } from './typing'
import { objectToQueryParam } from '@util/object'

const baseURL = `/${SYSADMIN}/notifications`

interface IdFilter {
  notification_type: string
  message_type: string
}

export const getMyNotifications = async (filter: IdFilter) => {
  const response = await client.get<INotification[]>(
    `${baseURL}/my-notifications${objectToQueryParam(filter)}`
  )
  return response.data
}
export const readnotification = async (id: string) => {
  const response = await client.get<INotification>(`${baseURL}/${id}/read`)
  return response.data
}
